import React from 'react';
import EditPhysicalProfile from './EditPhysicalProfile';
import { useAuth } from '../../../contexts/userContext/userContext';
import EditLegalProfile from './EditLegalProfile';

function EditProfileForm({
  handleSubmit,
  form,
  errors,
  options,
  setErrors,
}) {
  const { user } = useAuth();
  return (
    <div>
      {user?.type === 'physical'
          && (
          <EditPhysicalProfile
            form={form}
            handleSubmit={handleSubmit}
            errors={errors}
            options={options}
            setErrors={setErrors}
          />
          )}
      {user?.type === 'legal'
          && (
          <EditLegalProfile
            form={form}
            handleSubmit={handleSubmit}
            errors={errors}
            options={options}
          />
          )}
    </div>
  );
}
export default EditProfileForm;
